import { render, staticRenderFns } from "./OperaDispatch.vue?vue&type=template&id=d635e5f0&scoped=true&"
import script from "./OperaDispatch.vue?vue&type=script&lang=js&"
export * from "./OperaDispatch.vue?vue&type=script&lang=js&"
import style0 from "./OperaDispatch.vue?vue&type=style&index=0&id=d635e5f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d635e5f0",
  null
  
)

export default component.exports